module.exports = __webpack_public_path__ + "img/CM-MC-25-Buick-Playful.96eef5ba.jpg";